import { useState } from "react";
import { Badge, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import DstButton from "../../components/DstButton/DstButton";
import ListerSearch from "../../components/Lister/ListerSearch/ListerSearch";
import LiveLister from "../../components/Lister/LiveLister";
import TruncatedText from "../../components/TruncatedText/TruncatedText";
import { useSession } from "../../contexts/SessionContext";
import translate from "../../services/Translate";
import { completeNavigate } from "../../services/UtilityService";
import { generateRemoteUrl } from "./Programs.function";

export const Programs = () => {
  const { language } = useSession();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [fetchExternal, setFetchExternal] = useState(false);

  const columns = [
    { header: translate(language, "GLOBAL.ID"), key: "id", sortable: true },
    {
      header: translate(language, "GLOBAL.NAME"),
      key: "name",
      sortable: true,
    },
    {
      header: translate(language, "GLOBAL.DESCRIPTION"),
      key: "description",
      render: (program: any) => (
        <TruncatedText text={program.description || "N/A"} lines={3} customClassName="text-break" />
      ),
    },
    {
      header: translate(language, "GLOBAL.LANGUAGE"),
      key: "language",
      sortable: true,
      render: (program: any) => program.language || "N/A",
    },
    {
      header: translate(language, "PAGES.PROGRAMS.EXTERNAL"),
      key: "is_external",
      sortable: true,
      render: (program: any) =>
        program.is_external ? (
          <Badge bg="secondary">{translate(language, "PAGES.PROGRAMS.EXTERNAL")}</Badge>
        ) : (
          <Badge bg="success">{translate(language, "PAGES.PROGRAMS.INTERNAL")}</Badge>
        ),
    },
    {
      header: translate(language, "PAGES.PROGRAMS.HEADERS.MANAGER"),
      key: "manager",
      render: (program: any) => (
        <span
          className="text-primary clickable"
          onClick={(event) => {
            event.stopPropagation();
            completeNavigate(event, navigate, `/user/${program.manager.id}`);
          }}
        >
          {program.manager.full_name}
        </span>
      ),
    },
    {
      header: translate(language, "PAGES.PROGRAMS.HEADERS.POLE"),
      key: "pole",
      render: (program: any) => program.pole.name,
    },
  ];

  return (
    <div className="m-5 position-relative">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div className="d-flex align-items-center">
          <h2 className="mb-0 me-3">{translate(language, "PAGES.PROGRAMS.TITLE")}</h2>
          <ListerSearch setSearchQuery={setSearchQuery} timeDelay={500} showSearchIcon />
        </div>
        <DstButton
          btnClass="h-100 d-flex align-items-center"
          btnImageBefore={<Form.Check type="switch" className="check-box s-bold me-2" checked={fetchExternal} />}
          value={translate(language, "PAGES.PROGRAMS.FILTERS.SHOW_EXTERNAL")}
          variant="light"
          btnHeight="50px"
          clickFunction={() => setFetchExternal(!fetchExternal)}
        />
      </div>
      <LiveLister
        remote={generateRemoteUrl(searchQuery, fetchExternal)}
        remoteKey="programs"
        columns={columns}
        additionalButton={(item: any) => (
          <span
            className="clickable xs-regular"
            onClick={(event) => completeNavigate(event, navigate, `/program/${item.id}`)}
          >
            <span className="dst-icon-arrow-narrow-right m-regular" />
          </span>
        )}
        showHeader
        pagination
        paginationAlwaysShowFooter
        itemsPerPage={50}
      />
    </div>
  );
};

export default Programs;
